import React from "react";
import "./Offers.css"; 

const offersData = [
  {
    id: 1,
    image: "/Assets/1.jpeg", 
    tagline: "Family Room",
    description: "A spacious room featuring two single beds and one double bed, ideal for families. Includes a wardrobe, electric kettle, private bathroom with shower and hairdryer, and a flat-screen TV."
  },
  {
    id: 2,
    image: "/Assets/8.jpeg", 
    tagline: "Double Room",
    description: "A comfortable room with a double bed, perfect for couples. Equipped with a wardrobe, electric kettle, private bathroom with shower and hairdryer, and a flat-screen TV."
  },
  {
    id: 3,
    image: "/Assets/20.jpg", //
    tagline: "Twin Room",
    description: "A spacious room with two single beds, ideal for friends or colleagues. Includes a wardrobe, electric kettle, private bathroom with shower and hairdryer, and a flat-screen TV."
  }
];

const Offers = () => {
  return (
    <section className="offers-section" id="select-room">
      <h2 className="offers-title">Check out our latest offers</h2>
      <div className="offers-container">
        {offersData.map((offer) => (
          <div key={offer.id} className="offer-item">
            <img src={offer.image} alt={offer.tagline} className="offer-image" />
            <h3 className="offer-tagline">{offer.tagline}</h3>
            <p className="offer-description">{offer.description}</p>
            <a href={offer.tagline.replace(" ", "-").toLowerCase()}>Learn More</a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Offers;
